export default "__VITE_ASSET__$xDSULXz__"